import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { defaultSeasonStageExportFieldNames } from "~pages/SeasonStages/SeasonStageListPage/constants/exportFields.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useExportSeasonStages = () => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) =>
      await request(`${sport}/o/${organizationId}/seasons/${seasonId}/stages/export`, {
        method: "POST",
        body: {
          fieldNames: fieldNames || defaultSeasonStageExportFieldNames,
        },
      }),
  });
};
